import React from 'react';

function BrandSectionList(props) {

  const {items} = props;
  if (!Array.isArray(items) || items.length === 0) {
    return null;
  }

  return (
    <div className="mt-[75px] phone:mt-[45px]">
      <ul className="invisible-scrollbar flex gap-[15px] overflow-scroll phone:gap-[10px]">
        {items.map((section, index) => (
          <li
            key={`brand-section-${section.id || index}`}
            className="flex w-[220px] min-w-[220px] flex-col rounded-[12px] border border-solid border-[#EAEAEA] p-[16px] phone:min-w-[110px] phone:w-[110px] phone:p-2"
          >
            <a href={section.url} className="flex flex-col items-center gap-[10px]">
              {section.image?.src && (
                <img
                  className="h-[58px] w-[72px] object-contain"
                  src={section.image.src}
                  alt={section.image.alt || section.title || ''}
                  title={section.image.title || section.title || ''}
                  width={section.image.width || 72}
                  height={section.image.height || 58}
                  loading="lazy"
                  decoding="async"
                />
              )}
              <span className="text-[14px] text-center font-medium leading-normal text-[#1A1A1A] phone:text-[12px] phone:leading-[16px]">
                {section.title}
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BrandSectionList;